export default __webpack_public_path__ + "static/media/wind.7a74716f.svg";